import { useRef, useEffect, useContext } from "react";
import Chart from "chart.js/auto";
import { Spin } from "antd";
import { STATUS } from "../../constants";
import { memo } from "react";
import { UserContext } from "../../context";

const Chart18 = memo(({ kanbanFilterInfo, status }) => {
  const { parkId } = useContext(UserContext);
  const filterData = kanbanFilterInfo.filter((item) => item.cloumn === 3);
  const allyear = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 4 + index
  );
  const element = useRef();

  useEffect(() => {
    let counts = [];
    if (filterData.length > 0) {
      const data = filterData[0].context
        .filter((item) => allyear.includes(Number.parseInt(item.year)))
        .sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year));

      counts = allyear.map((year) => {
        const item = data.find((obj) => obj.year === year.toString());
        return item ? item.count : 0;
      });
    }
    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: allyear,
        datasets: [
          {
            data: parkId === 69 ? [52, 70, 88, 122, 167] : counts,
            fill: true,
            borderColor: "#e76f51",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,
            // max: 1000,
            // ticks: { stepSize: 1 }
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: false,
        },
      },
    });
    return () => chart.destroy();
  }, [filterData, allyear]);
  return (
    <Spin spinning={status === STATUS.idle}>
      <canvas ref={element} />
    </Spin>
  );
});
export default Chart18;
